import React, { createContext, useContext, useState } from 'react';

interface ChatContextType {
  hasActiveChat: boolean;
  setActiveChat: (active: boolean) => void;
  /** True once the user has submitted a message through SunnyChat this session.
   * Distinct from `hasActiveChat`, which IntercomBubble also flips on any messenger
   * visibility (help center, past conversations, unread notifications). SunnyChat's
   * cross-route launcher persistence should only kick in on this narrower flag. */
  hasActiveSunnyChat: boolean;
  setActiveSunnyChat: (active: boolean) => void;
  unreadCount: number;
  setUnreadCount: (count: number) => void;
  isMessengerOpen: boolean;
  setMessengerOpen: (open: boolean) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChat = (): ChatContextType => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasActiveChat, setActiveChat] = useState(false);
  const [hasActiveSunnyChat, setActiveSunnyChat] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isMessengerOpen, setMessengerOpen] = useState(false);

  const value = {
    hasActiveChat,
    setActiveChat,
    hasActiveSunnyChat,
    setActiveSunnyChat,
    unreadCount,
    setUnreadCount,
    isMessengerOpen,
    setMessengerOpen,
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
